import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmDialog } from '@klareospace/pharos-lib-web-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface CancelOrderDialogProps {
  readonly isPending: boolean;
  readonly onConfirm: () => void;
  readonly onOpenChange: (open: boolean) => void;
  readonly open: boolean;
  readonly referenceNumber: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function CancelOrderDialog({
  isPending,
  onConfirm,
  onOpenChange,
  open,
  referenceNumber,
}: CancelOrderDialogProps): React.JSX.Element {
  const { t } = useTranslation('orders');

  return (
    <ConfirmDialog
      cancelLabel={t('drawer.actions.cancel.dialog.cancel')}
      confirmLabel={t('common.cancelOrderLabel')}
      description={t('drawer.actions.cancel.dialog.description', { reference: referenceNumber })}
      destructive
      isPending={isPending}
      onConfirm={onConfirm}
      onOpenChange={onOpenChange}
      open={open}
      title={t('common.cancelOrderLabel')}
    />
  );
}
